import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { ClipLoader } from "react-spinners";
import axios from "axios";

const GrievanceResForm = ({ nep, PageTitle }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    formState,
  } = useForm();
  const { isSubmitting } = formState;
  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState(null);
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_URL}grievance/check`,
        values
      );
      if (data?.error) {
        toast.error(data.error);
        setLoading(false);
      } else if (data?.status_code === 307) {
        toast.error(
          nep
            ? "इमेल वा सबमिशन कोड मेल खाँदैन।"
            : "Email or Submission Code does not match"
        );
        setLoading(false);
      } else if (data?.status_code === 200) {
        setResData(data);
        toast.success(nep ? "सबमिशन कोड प्रमाणित" : "Submission Code Verified");
        setLoading(false);
      }
    } catch (err) {
      toast.error("Failed to send. Please try again.");
      // console.log(err);
      setLoading(false);
    }
  };
  return (
    <>
      {resData?.status_code === 200 ? (
        <div className="grievanceFormResponseAnsMainContainer">
          <h4 className="grievanceFormResHead">
            {nep ? "नमस्ते" : "Hello"} , {resData?.grevience.name}
          </h4>
          <p className="grievanceFormResSubHead">
            {nep ? "तपाईंले पोस्ट गर्नुभएको मुद्दा" : "The issue you posted on"}
            {resData.grevience.created}
            {resData.grevience.status === "0" ? (
              <span>
                {nep
                  ? "यो प्रक्रियामा छ। कृपया पछि फेरि जाँच गर्नुहोस्।"
                  : "is under process. Please check again later."}
              </span>
            ) : (
              <span>
                {nep
                  ? "यसको जवाफ पहिले नै दिइसकिएको छ।"
                  : "is already answered."}
              </span>
            )}
          </p>
          <h5 className="grievanceFormResIssue">
            {nep ? "मुद्दा" : "Issue"} :
          </h5>
          <p className="grievanceFormResIssueSubject">
            {resData.grevience.subject}
          </p>
          <p className="grievanceFormResIssueText">
            {isReadMore
              ? resData.grevience.issue.slice(0, 400)
              : resData.grevience.issue}
            {resData.grevience.issue.length > 400 && (
              <span onClick={toggleReadMore} className="read-or-hide">
                {isReadMore ? "... read more" : " show less"}
              </span>
            )}
          </p>
          {resData.grevience.issue_reply !== null && (
            <h5 className="grievanceFormResIssue">
              {nep ? "जवाफ" : "Answer"} :
            </h5>
          )}
          <p
            className="grievanceFormResIssueAns"
            dangerouslySetInnerHTML={{
              __html: resData.grevience.issue_reply,
            }}
          ></p>
        </div>
      ) : (
        <div className="grievanceFormMainContainer">
          <div className="grievancePageFormContainer">
            <h3>
              {nep ? "आफ्नो परिणाम जाँच गर्नुहोस्।" : "Check your result."}
            </h3>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group">
                <label>{nep ? "इमेल ठेगाना" : "Email Address"}</label>
                <input
                  type="text"
                  placeholder={nep ? "इमेल ठेगाना" : "Email Address"}
                  name="email"
                  {...register("email", {
                    required: "Email is Required",
                    pattern: {
                      value:
                        /^([a-z0-9_\.\+-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/,
                      message: "Invalid email address",
                    },
                  })}
                  className="form-control"
                />
                <span>{errors.email?.message}</span>
              </div>
              <div className="form-group">
                <label>{nep ? "सबमिशन कोड" : "Submission Code "}</label>
                <input
                  type="text"
                  placeholder={nep ? "सबमिशन कोड" : "Submission Code "}
                  name="user_code"
                  {...register("user_code", {
                    required: "Submission Code is Required",
                  })}
                  className="form-control"
                />
                <span>{errors.user_code?.message}</span>
              </div>
              <button
                className="btn btn-sm btn-primary"
                type="submit"
                disabled={isSubmitting}
              >
                {loading && <ClipLoader size={20} color="#fff"></ClipLoader>}
                {nep ? "जाँच गर्नुहोस्" : "Check "}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
export default GrievanceResForm;
